<template>
  <base-modal height="600"
              :show="show"
              @close="close">
    <div slot="header">
      {{ $t("customFilters") }}
    </div>

    <custom-content-filter :mode-id="fromBus.modeId"
                           :child-id="fromBus.childId" />
  </base-modal>
</template>

<script>
  import CustomContentFilter from '@/components/Child/ChildCustomFilter/CustomFilter'
  import modalMixin from '@/mixins/modalMixin'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      CustomContentFilter
    },

    data() {
      return {
        fromBus: {
          modeId: '',
          childId: ''
        }
      }
    },

    beforeMount() {
      this.setOpenListener('customFilters')
    }
  }
</script>